<div class="my_order_sec">
  <div class="my_order_head">
    <form action="" [formGroup]="filterForm" class="form-section my_order_form">
      <div class="order_management" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
        fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
        <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
          fxFlexFill>
          <div class="filter_flex">
            <!-- All Supplier -->
            <div class="custom-form-group">
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="supplier_id" (selectionChange)="setStatus()"
                    placeholder="Select Supplier">
                    <mat-option value=""> Select Supplier </mat-option>
                    <mat-option *ngFor="let singleSupplier of dentalSuppliersList" [value]="singleSupplier.id">
                      {{singleSupplier.business_name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <!-- Order Status -->
            <div class="custom-form-group">
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="status" (selectionChange)="setStatus()"
                    placeholder="Select Order Status">
                    <mat-option value=""> Select Order status </mat-option>
                    <mat-option value="PENDING"> Pending </mat-option>
                    <mat-option value="APPROVED"> Approved </mat-option>
                    <mat-option value="PARTIALLY_SHIPPED"> Partially Shipped</mat-option>
                    <mat-option value="SHIPPED"> Shipped</mat-option>
                    <mat-option value="DELIVERED"> Delivered </mat-option>
                    <mat-option value="CANCELLED"> Cancelled</mat-option>
                    <mat-option value="REFUNDED"> Refunded </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="custom-form-group date_group">
              <div class="custom-form-control">
                <mat-form-field appearance="outline">
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate formControlName="start" placeholder="Start date" (dateInput)="setDateFilter()"
                      (click)="picker.open()">
                    <input matEndDate formControlName="end" placeholder="End date" (dateInput)="setDateFilter()"
                      (click)="picker.open()">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker-toggle matSuffix (click)="clear()" *ngIf="start.value && end.value">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
              </div>
            </div>
            <button type="button" mat-button class="btn btn-sm clear_filter_btn" *ngIf="showClearButton()"
            (click)="clearFilters()">
              Clear Filters
            </button>
          </div>
        </div>

      </div>
    </form>
  </div>
  <!-- order_box -->
  <ng-container *ngIf="suppliesOrdersList; else loadingTemplate">
    <ng-container *ngIf="suppliesOrdersList.length;else noDataTemplate">
      <div class="order_box " *ngFor="let singleSupplierOrder of suppliesOrdersList">
        <div class="order_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
          fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
          <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
            fxFlexFill>
            <div class="order_flex">
              <div>
                <h4 class="primary"><a [routerLink]="['/profile/orders', singleSupplierOrder.id]">
                    Order No : {{singleSupplierOrder.order_number}}</a></h4>
                <p class="order_date">Order at : {{singleSupplierOrder.created_at | date: 'dd/MM/yyyy'}}</p>
                <p class="order_date"> Order status : <span class="table-chip" [ngClass]="{
                  'pending-chip': singleSupplierOrder.status==='PENDING',
                  'processing-chip': singleSupplierOrder.status==='PARTIALLY_SHIPPED' || singleSupplierOrder.status==='SHIPPED',
                  'cancelled-chip': singleSupplierOrder.status==='CANCELLED',
                  'active-chip': singleSupplierOrder.status==='APPROVED'|| singleSupplierOrder.status==='DELIVERED'}">{{singleSupplierOrder.status | titlecase}}</span></p>
              </div>
              <div>
                <h4 class="secondary">Amount : AUD {{singleSupplierOrder.total_amount.toFixed(2)}}</h4>
                <p class="order_total">Total : AUD {{singleSupplierOrder.total_amount.toFixed(2)}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="address_row_box">
          <div class="row-wrap  address_admin" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
            fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch">
            <div class="column address_admin_col" fxFlex.xl="40" fxFlex.lg="40" fxFlex.md="40" fxFlex.sm="100"
              fxFlex.xs="100" fxFlexFill>
              <div class="address_box">
                <h4>Shipping address :</h4>
                <div class="media">
                  <div class="media-left">
                    <img src="../../../../../assets/images/icons/address.jpg" alt="">
                  </div>
                  <div class="media-body">
                    <p *ngIf="singleSupplierOrder?.shipping_address?.short_name">{{singleSupplierOrder?.shipping_address?.short_name}},</p>
                    <p *ngIf="singleSupplierOrder?.shipping_address?.line_1">{{singleSupplierOrder?.shipping_address?.line_1}},</p>
                    <p *ngIf="singleSupplierOrder?.shipping_address?.line_2 && singleSupplierOrder?.shipping_address?.landmark">
                      {{singleSupplierOrder?.shipping_address?.line_2}},
                      {{singleSupplierOrder?.shipping_address?.landmark}},</p>
                    <p *ngIf="singleSupplierOrder?.shipping_address?.city && singleSupplierOrder?.shipping_address?.state && singleSupplierOrder?.shipping_address?.postal_code">
                      {{singleSupplierOrder?.shipping_address?.city}},
                      {{singleSupplierOrder?.shipping_address?.state}},
                      {{singleSupplierOrder?.shipping_address?.postal_code}}</p>
                    <p *ngIf="singleSupplierOrder?.shipping_address?.country">{{singleSupplierOrder?.shipping_address?.country}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="column address_admin_col" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="100"
              fxFlex.xs="100" fxFlexFill>
              <div class="address_box customer_info" *ngIf="singleSupplierOrder.dental_practice">
                <h4>Customer info :</h4>
                <p>{{singleSupplierOrder.dental_practice.name}}</p>
                <p>{{singleSupplierOrder.dental_practice.phone}}</p>
                <p>{{singleSupplierOrder.dental_practice.email}}</p>
              </div>
              <div class="address_box customer_info" *ngIf="singleSupplierOrder.dental_professional">
                <h4>Customer info</h4>
                <p>{{singleSupplierOrder.dental_professional.name}}</p>
                <p>{{singleSupplierOrder.dental_professional.phone}}</p>
                <p>{{singleSupplierOrder.dental_professional.email}}</p>
              </div>
              <div class="address_box customer_info" *ngIf="singleSupplierOrder.dental_supplier">
                <h4>Customer info</h4>
                <p>{{singleSupplierOrder.dental_supplier.name}}</p>
                <p>{{singleSupplierOrder.dental_supplier.phone}}</p>
                <p>{{singleSupplierOrder.dental_supplier.email}}</p>
              </div>
            </div>
            <div class="column address_admin_col" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="100"
              fxFlex.xs="100" fxFlexFill>
              <div class="support_btns">
                <button type="button" class="btn btn-sm global-btn cancel_btn" mat-button
                  (click)="cancelOrder(singleSupplierOrder)"
                  *ngIf="singleSupplierOrder.status === 'PENDING'">Cancel</button>
                <button type="button" class="btn btn-sm global-btn support_btn" mat-button
                  (click)="supportRequestDialog(singleSupplierOrder)">Support</button>
                <button type="button" class="btn btn-sm global-btn support_btn" mat-button
                *ngIf="singleSupplierOrder.status ==='DELIVERED'"
                  (click)="viewInvoice(singleSupplierOrder)"> View Invoice </button>
              </div>
            </div>
          </div>
        </div>
        <!-- WEB-TRACK -->
        <!-- <div class="order_track web_order_track" fxLayoutAlign="center center" fxShow="true" fxShow.lt-sm="false">
          <ul>
            <li class="completed" *ngFor="let singleUpdate of singleSupplierOrder.supplies_order_notes;let i = index">
              <span class="circles" [ngClass]="singleUpdate?.status"></span>
              <span class="bar" *ngIf="i+1 < singleSupplierOrder?.supplies_order_notes.length"></span>
              <h4>{{singleUpdate.status}}</h4>
              <span class="time">
                {{singleUpdate.created_at|date: 'dd-MM-yyyy hh:mm:ss' }}
              </span>
            </li>
          </ul>
        </div> -->
        <!-- MOBILE-TRACK -->
        <div class="mobile_order_track">
          <div class="order-track" [@openCloseStatus]="openStatus ? true : false">
            <div class="order-track-step"
              *ngFor="let singleUpdate of singleSupplierOrder?.supplies_order_notes;let i = index">
              <div class="order-track-status">
                <span class="order-track-status-dot" [ngClass]="singleUpdate?.status"></span>
                <span class="order-track-status-line"
                  *ngIf="i+1 < singleSupplierOrder?.supplies_order_notes.length"></span>
              </div>
              <div class="order-track-text">
                <p class="order-track-text-stat">{{singleUpdate.status}}</p>
                <span class="order-track-text-sub">{{singleUpdate.created_at |date: 'dd-MM-yyyy hh:mm:ss' }}</span>
              </div>
            </div>
          </div>
          <div class="view_all_status" *ngIf="singleSupplierOrder?.supplies_order_notes.length >= 3">
            <a (click)="filterToggleStatus()">View all status</a>
          </div>
        </div>
        <div class="view_order_details">
          <a title="view order details" [routerLink]="['/profile/orders', singleSupplierOrder.id]">
            <img src="../../../../../assets/images/icons/right.svg" alt="">
          </a>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #loadingTemplate>
    <div class="custom-loader custom_logo_loader">
      <img src='../../../../../images2/loader.gif' alt="img" loading="lazy" />
    </div>
  </ng-template>
  <!-- no-data -->
  <ng-template #noDataTemplate>
    <div class="no-data empty-img">
        <!-- EMPTY-STATE -->
  <img src='../../../../../../../assets/images/empty-imgs/no_orders.svg' alt="img" loading="lazy" />
  <h4 class="no_state_heading">No Orders</h4>
    </div>
  </ng-template>
  <!-- TABLE-PAGINATOR -->
  <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column" fxFlexFill
    fxLayoutGap="8px">
    <mat-paginator [length]="totalElements" [pageSize]="limit.value" (page)="changePage($event)"></mat-paginator>
  </div>
</div>

